import Vue from "vue"
import Drawflow from "drawflow"
import FlowchartBlock from "@/modules/flowcharts/components/flowchart-block"
import { connectionCreated, connectionRemoved } from "@/modules/flowcharts/flowchart-utils"
import { i18n } from "@/plugins/i18n"

export default {
	namespaced: true,
	state: {
		nodes: [],
		editor: undefined,
		showModalQuestion: false,
		showModalEdit: undefined,
		showModalWiki: false,
		showModalInsert: false,
		selected_id: undefined,
		node_template: {
			id: 0,
			titolo: i18n.t("new-node") + " - 0",
			children: [],
			parent: [],
			value: [{ name: "", id: 0, items: [] }],
			answer: undefined,
			question: {
				value: "",
				map: []
			},
			zip_attachments: []
		}
	},
	getters: {
		nodes: state => state.nodes,
		node_value: state => id => {
			return state.nodes.find(x => x.id == id)
		},
		node_value_builder: state => id => state.nodes[id].value,
		editor: state => state.editor,
		showModalQuestion: state => state.showModalQuestion,
		showModalEdit: state => state.showModalEdit,
		showModalWiki: state => state.showModalWiki,
		showModalInsert: state => state.showModalInsert,
		selected_id: state => state.selected_id,
		isQuestion: state => id => {
			var ind = state.nodes.findIndex(i => i.id == id)
			if (ind == -1) {
				return false
			}
			return state.nodes[ind].question.value == ""
		}
	},
	mutations: {
		/* editor */
		SET_EDITOR(state, val) {
			state.editor = val
		},
		/* nodi */
		PUSH_NODE(state, payl2) {
			if (payl2.identificativo !== undefined) {
				payl2.id = undefined
				payl2.id = payl2.identificativo
			}
			state.nodes.push(payl2)
		},
		RESET_NODES(state) {
			state.nodes = []
		},
		REMOVE_NODE(state, node_id) {
			var ind = state.nodes.findIndex(i => i.id == node_id)
			state.nodes.splice(ind, 1)
		},
		UPDATE_NODE(state, { node_id, val }) {
			var ind = state.nodes.findIndex(i => i.id == node_id)
			state.nodes[ind] = val
		},
		EDIT_NODE_VAL(state, { node_id, val }) {
			var ind = state.nodes.findIndex(i => i.id == node_id)
			state.nodes[ind].value = val
		},
		/* modali */

		EDIT_MODAL_QUESTION(state, val) {
			state.showModalQuestion = val
		},
		EDIT_MODAL_EDIT(state, val) {
			state.showModalEdit = val
		},
		EDIT_MODAL_WIKI(state, val) {
			state.showModalWiki = val
		},
		EDIT_MODAL_INSERT(state, val) {
			state.showModalInsert = val
		},
		EDIT_SELECTED_ID(state, val) {
			state.selected_id = val
		},
		KILL_EVERYTHING(state) {
			state.nodes = []
			state.editor = undefined
			state.showModalQuestion = false
			state.showModalEdit = undefined
			state.showModalInsert = false
			//state.selected_id = undefined
			//state.node_template = {id : 0, titolo : "Nuovo Nodo - " + 0, children :[], parent :  [], value : [{ name: "", id: 0, items: [] },], answer : undefined, question : {value: "",map: []} }
		}
	},
	actions: {
		/* editor */
		setEditor({ state, commit }, val) {
			commit("SET_EDITOR", val)
			return true
		},
		async initEditor({ state, commit, dispatch }, store, router) {
			var id = document.getElementById("drawflow")
			var editor2 = new Drawflow(id, Vue)
			editor2.curvature = 0.3
			editor2.zoom_min = 0.05
			editor2.zoom_value = 0.05
			editor2.start()
			editor2.on("connectionCreated", value => {
				connectionCreated(value, state.nodes, state.editor, dispatch)
			})
			editor2.on("connectionRemoved", value => {
				connectionRemoved(value, state.nodes, dispatch)
			})
			editor2.on("nodeMoved", async id => {
				var tmp = state.nodes.find(x => x.id == id)
				var coord = await state.editor.getNodeFromId(id)
				tmp.coordinates = coord.pos_x + "," + coord.pos_y
				commit("UPDATE_NODE", { node_id: id, val: tmp })
			})
			dispatch("setEditor", editor2)
			var newNode = await dispatch("initNode")
			dispatch("pushNode", { node: newNode, store: store, router: router })
		},

		//reset e caricamento editor con flowcart esistente, oppure lo crea da zero con dati passati
		async cleanAndResetEditor({ state, commit, dispatch }, { store, nodi }) {
			if (!state.editor) {
				var id = await document.getElementById("drawflow")
				var editor2 = new Drawflow(id, Vue)
				editor2.curvature = 0.3
				editor2.zoom_min = 0.05
				editor2.zoom_value = 0.05

				await editor2.start()

				editor2.on("connectionCreated", value => connectionCreated(value, state.nodes, state.editor, dispatch))
				editor2.on("connectionRemoved", value => {
					connectionRemoved(value, state.nodes, dispatch)
				})
				editor2.on("nodeMoved", async id => {
					var tmp = state.nodes.find(x => x.id == id)
					var coord = await state.editor.getNodeFromId(id)
					tmp.coordinates = coord.pos_x + "," + coord.pos_y
					commit("UPDATE_NODE", { node_id: id, val: tmp })
				})
				await dispatch("setEditor", editor2)
			} else {
				state.editor.clear()
			}
			var nextIsChildren = undefined
			var x = 0
			var y = 0
			for (var i = 0; i < nodi.length; i++) {
				var templateNode = await dispatch("initNode")
				var tmp = undefined
				tmp = JSON.parse(JSON.stringify(templateNode))
				var tmpNodo = undefined
				tmpNodo = JSON.parse(JSON.stringify(nodi[i]))

				tmp.children = tmpNodo.children
				tmp.parent = tmpNodo.parent
				tmp.name = tmpNodo.titolo
				tmp.titolo = tmpNodo.titolo
				tmp.id = tmpNodo.id !== null ? tmpNodo.id : i
				tmpNodo.identificativo = tmpNodo.id !== null ? tmpNodo.id : i
				if (tmpNodo.value) {
					var tttmp = { id: 0, items: [], name: "" }
					tmpNodo.value.forEach(el78 => {
						var tmppppp = JSON.parse(el78.items)
						if (el78.block_type === "shared_blocks") {
							tmppppp.ref_id = el78.block_id
						}
						tmppppp.name = el78.name
						tmppppp.wiki = el78.wiki
						tttmp.items.push(tmppppp)
					})

					tmpNodo.value = [tttmp]
				} else {
					tmpNodo.value = [{ id: 0, items: [], name: "" }]
				}
				delete nodi[i]["Items"]
				await commit("PUSH_NODE", tmpNodo)
				if (nextIsChildren) {
					if (nextIsChildren.total_length > 0) {
						x = nextIsChildren.x
					}
				}
				var tmp_x = x
				var tmp_y = y
				if (tmpNodo.coordinates) {
					tmp_x = tmpNodo.coordinates.split(",")[0]
					tmp_y = tmpNodo.coordinates.split(",")[1]
				}
				tmp.coordinates = tmp_x + "," + tmp_y
				await dispatch("registerNode", {
					node: tmp,
					store: store,
					router: this.$router,
					offset1: tmp_x,
					offset2: tmp_y
				})
				y = y + 300
				x = 0
				if (nextIsChildren) {
					if (nextIsChildren.total_length > 0) {
						nextIsChildren.x = nextIsChildren.x - 300
					}
				}
				if (tmp.children.length > 1) {
					nextIsChildren = {
						total_length: tmp.children.length,
						x: (tmp.children.length - 1) * 300
					}
				} else {
					if (nextIsChildren) {
						nextIsChildren.total_length--
					}
				}
			}
			var nodeCopy = JSON.parse(JSON.stringify(state.nodes))
			for (let i = 0; i < nodeCopy.length; i++) {
				if (nodeCopy[i].question.map.length > 0) {
					for (let iiiii = 1; iiiii < nodeCopy[i].question.map.length; iiiii++) {
						await state.editor.addNodeOutput(state.nodes[i].id)
					}
				}

				for (let j = 0; j < nodeCopy[i].children.length; j++) {
					let childNodes = undefined
					try {
						childNodes = await state.editor.getNodeFromId(state.nodes[i].children[j])
					} catch (err) {
						console.error("no node found, skip")
						continue
					}

					//errore pallini che scompaiono
					// if (Number(j) + 1 >= 1) {
					if (nodeCopy[i].question.map.length > 0) {
					} else {
						//questa cosa ddecide se e quando aggiungere pallini di output a una domanda
						if (Number(j) + 1 >= 1 && Number(j) + 1 < nodeCopy[i].children.length) {
							await state.editor.addNodeOutput(state.nodes[i].id)
						}
					}

					await state.editor.addConnection(
						state.nodes[i].id,
						state.nodes[i].children[j],
						"output_" + (Number(j) + 1),
						Object.keys(childNodes.inputs)[Object.keys(childNodes.inputs).length - 1]
					)
					if (childNodes.data.parent.length > 1 && j < nodeCopy[i].children.length) {
						await state.editor.addNodeInput(state.nodes[i].children[j])
					}
				}
			}
			return true
		},
		/* nodi */
		/* pusha in casi particolari il nodo ad esempio l'init del flowchart, DA NON USARE PER TUTTO IL RESTO*/
		/*usa register node */
		async pushNode({ state, commit, rootState, dispatch }, { node, store, offset1 = 0, offset2 = 0 }) {
			await commit("PUSH_NODE", node)
			//no, sotto
			await state.editor.registerNode("flowchart-block", FlowchartBlock, node, {
				store: store,
				router: this.$router,
				i18n: i18n
			})
			//state.editor.addNode( node.id, node.name, ((node.id===0) ? 0 : 1), 1, 0, 0, '', node, 'flowchart-block', 'vue' );
			await state.editor.addNode(
				node.id,
				node.name,
				node.id == 0 ? 0 : 1,
				1,
				offset1,
				offset2,
				"",
				node,
				"flowchart-block",
				"vue"
			)
			return true
		},
		async registerNode({ state, commit, rootState, dispatch }, { node, store, router, offset1 = 0, offset2 = 0 }) {
			await state.editor.registerNode("flowchart-block", FlowchartBlock, node, {
				store: store,
				router: router,
				i18n: i18n
			})
			//state.editor.addNode( node.id, node.name, ((node.id===0) ? 0 : 1), 1, 0, 0, '', node, 'flowchart-block', 'vue' );
			await state.editor.addNode(
				node.id,
				node.name,
				node.id == 0 ? 0 : 1,
				1,
				offset1,
				offset2,
				"",
				node,
				"flowchart-block",
				"vue"
			)
			return true
		},
		async cloneNode({ state, commit, dispatch }, { node_id, store }) {
			var ind = state.nodes.findIndex(i => i.id == node_id)
			var node = JSON.parse(JSON.stringify(state.nodes[ind]))
			node.children = []
			node.parent = []
			node.titolo += "(" + i18n.t("copy") + ")"
			node.answer = undefined
			node.question = { value: "", map: [] }
			node.id = state.nodes[state.nodes.length - 1].id + 1
			node.identificativo = undefined
			node.coordinates =
				Number(node.coordinates.split(",")[0]) + 10 + "," + (Number(node.coordinates.split(",")[1]) + 10)
			dispatch("pushNode", {
				node: node,
				store: store,
				offset1: Number(node.coordinates.split(",")[0]) + 10,
				offset2: Number(node.coordinates.split(",")[1]) + 10
			})
		},
		async delNode({ state, commit, dispatch }, node) {
			// var tmp = state.nodes.find(i=> Number(i.id)===Number(node))
			// tmp.children.forEach((el)=>{
			//
			// 	var tmp2 = state.nodes.find(i=> i.id==el)
			// 	tmp2.parent= tmp2.parent.filter(i => i != node)
			// 	commit( "UPDATE_NODE", { node_id: tmp2.id, val: tmp2 } )
			// 	// var value
			// 	// connectionRemoved(value,state.nodes, dispatch )
			// })

			state.editor.removeNodeId("node-" + node)
			commit("REMOVE_NODE", node)
		},
		async editNode({ state, commit }, { node_id, val }) {
			commit("EDIT_MODAL_INSERT", val)
			commit("EDIT_SELECTED_ID", node_id)
		},
		editNodeValue({ state, commit }, { node_id, val }) {
			commit("EDIT_NODE_VAL", { node_id, val })
			commit("EDIT_SELECTED_ID", val)
		},
		/* modali */
		editModalQuestion({ state, commit }, { node_id, val }) {
			commit("EDIT_MODAL_QUESTION", val)
			commit("EDIT_SELECTED_ID", val)
		},
		editModalEdit({ state, commit }, { val, id }) {
			commit("EDIT_MODAL_EDIT", id)
			commit("EDIT_SELECTED_ID", id)
		},
		editModalInsert({ state, commit }, { node_id, val }) {
			commit("EDIT_MODAL_INSERT", val)
			commit("EDIT_SELECTED_ID", val)
		},

		editWikiModal({ state, commit }, { val, id }) {
			commit("EDIT_MODAL_WIKI", val)
			commit("EDIT_SELECTED_ID", id)
		},

		/* altre cose magiche che per adesso NON vanno toccate*/

		initNode({ state }) {
			var ret = JSON.parse(JSON.stringify(state.node_template))
			var last_id = 0
			if (state.nodes.length > 0) {
				last_id = state.nodes[state.nodes.length - 1].id + 1
			}
			ret.id = last_id
			ret.titolo = i18n.t("new-node") + " - " + last_id
			ret.answer = undefined
			ret.coordinates = "0,0"
			return ret
		},
		async newNode({ state, commit, dispatch }, store) {
			var newNode = await dispatch("initNode")
			newNode.coordinates =
				Number(state.nodes[state.nodes.length - 1].coordinates.split(",")[0]) +
				10 +
				"," +
				(Number(state.nodes[state.nodes.length - 1].coordinates.split(",")[1]) + 10)
			await dispatch("pushNode", {
				node: newNode,
				store: store,
				offset1: Number(state.nodes[state.nodes.length - 1].coordinates.split(",")[0]) + 10,
				offset2: Number(state.nodes[state.nodes.length - 1].coordinates.split(",")[1]) + 10
			})
		},
		async showQuestion({ state, commit, rootState, dispatch }, node_id) {
			commit("EDIT_MODAL_QUESTION", true)
			commit("EDIT_SELECTED_ID", node_id)
		},
		async setQuestion({ state, commit, rootState, dispatch }, node_id) {
			var node = state.nodes.findIndex(i => i.id == node_id)
			var node2 = await state.editor.getNodeFromId(node_id)
			commit("EDIT_MODAL_QUESTION", true)
			var edit = state.nodes[node]
			if (edit.question.map === [] && edit.question.value !== "") {
				edit.question = {
					value: "",
					map: []
				}
			}
			if (edit.question.map.length < Object.keys(node2.outputs).length) {
				var map = []
				for (let i = edit.question.map.length; i < Object.keys(node2.outputs).length; i++) {
					edit.question.map.push({
						value: "",
						ref: undefined
					})
				}
			}
			if (edit.question.map.length > Object.keys(node2.outputs).length) {
				var map = []
				for (let i = edit.question.map.length; i > Object.keys(node2.outputs).length; i--) {
					edit.question.map.pop()
				}
			}
			if (edit.question.value != "") {
				edit.question.map.forEach(el => {
					if (el.ref !== undefined) {
						var indx = state.nodes.findIndex(i => i.id == el.ref)
						var tmp = state.nodes[indx]
						tmp.answer = el.value
						commit("UPDATE_NODE", { node_id: el.ref, val: tmp })
					}
				})
			}
			commit("EDIT_SELECTED_ID", node_id)
			commit("UPDATE_NODE", { node_id: node_id, val: edit })
		},
		async resetQuestion({ state, commit, rootState }, node_id) {
			var node = state.nodes.findIndex(i => i.id == node_id)
			var node2 = await state.editor.getNodeFromId(node_id)
			//commit( "EDIT_MODAL_QUESTION", true )
			var edit = state.nodes[node]
			edit.question = {
				value: "",
				map: []
			}
			for (const el of Object.values(node2.outputs)) {
				await state.editor.removeNodeOutput(node_id, "output_1", true)
			}
			state.editor.addNodeOutput(node_id)

			edit.children.forEach(el => {
				var tmp = state.nodes.find(i => i.id == el)
				tmp.parent = tmp.parent.filter(i => i != node_id)
				commit("UPDATE_NODE", { node_id: tmp.id, val: tmp })
			})
			edit.children = []
			//Object.keys(node2.outputs).length
			commit("EDIT_SELECTED_ID", node_id)
			commit("UPDATE_NODE", { node_id: node_id, val: edit })
		},
		endSetQuestion({ state, commit, rootState }) {
			commit("EDIT_MODAL_QUESTION", false)
			commit("EDIT_SELECTED_ID", undefined)
		},
		endSetProp({ state, commit, rootState }) {
			commit("EDIT_MODAL_INSERT", false)
			commit("EDIT_SELECTED_ID", undefined)
		},
		removeQuestion({ state, commit, rootState }, node) {
			commit("PUSH_NODE", node)
		},
		editNodeDependecies({ state, commit, rootState }, { node_id, parent, children, question, answer }) {
			var node = state.nodes.find(i => i.id == node_id)
			if (parent !== undefined) {
				node.parent = parent
			}
			if (children !== undefined) {
				node.children = children
			}
			if (question !== undefined) {
				node.question = question
			}
			if (answer !== undefined) {
				node.answer = answer
			}
			commit("UPDATE_NODE", { node_id: node_id, val: node })
		},
		/* FINE cose magiche */

		verifyBalls({ state, commit, rootState }) {
			return true
			//non serve più?
			var exportdata = state.editor.export()
			var isValid = true
			Object.values(exportdata.drawflow.Home.data).forEach(el => {
				Object.values(el.inputs).forEach(el2 => {
					if (el2.connections.length === 0) {
						isValid = false
					}
				})
			})
			if (!isValid) {
				/**/
				alert(i18n.t("warning-input"))
			}
			return isValid
		}
	}
}
